import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import getClientConfig from '../../utils/getClientConfig';
import { getAccessToken } from '../../utils/tokenStorage';

/* Container component for the AVI Chatbot (ipua-panel).
 * Renders the IPUA panel and sets up the access token provider.
 * Uses the same token source as Header (getAccessToken from tokenStorage).
 */
const AviChatbotContainer = ({ featureFlags }) => {
    const { aviIdentityEnv } = getClientConfig();
    const canViewAviChatbot = !!featureFlags?.EnableAviChatbot;
    const ipuaRef = useRef(null);

    // IPUA panel expects URL without protocol prefix (e.g., "identity.ci.avalara.io")
    const identityUrl = aviIdentityEnv
      ? aviIdentityEnv.replace(/^https?:\/\//, '')
      : 'identity.ci.avalara.io';

    // Set up the access token function for the IPUA panel (same logic as Header.requestCurrentAccessToken)
    useEffect(() => {
      const panel = ipuaRef.current;
      if (!panel) {
        return;
      }

      panel.getaccesstoken = () => {
        const currentToken = getAccessToken();
        return Promise.resolve({ accessToken: currentToken });
      };
    }, [canViewAviChatbot]);

    if (!canViewAviChatbot) {
      return null;
    }

    return (
      <ipua-panel
        ref={ipuaRef}
        product="vat-reporting"
        url={identityUrl}
      />
    );
};

function mapStateToProps(state) {
  return {
    featureFlags: state.featureFlag && state.featureFlag.data
  };
}

export default connect(mapStateToProps)(AviChatbotContainer);
